import { Component } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Envsetting } from '../../../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EoiExhibitionFileViewerComponent } from '../eoi-exhibition-file-viewer/eoi-exhibition-file-viewer.component';



@Component({
  selector: 'app-eoi-exhibition-view',
  templateUrl: './eoi-exhibition-view.component.html',
  styleUrl: './eoi-exhibition-view.component.css'
})
export class EoiExhibitionViewComponent {
  ApplicationId!: string;
  exhibitionData: any;
  baseUrl = Envsetting.apiBaseUrl;
  constructor(private apiService: ApiService, private route: ActivatedRoute, private router: Router,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    this.ApplicationId = this.route.snapshot.paramMap.get('applicationId')!;

    this.getEoiExhibitionViewList();
  }

  getEoiExhibitionViewList() {
    const params = {
      applicationId: this.ApplicationId
    };

    this.apiService.getRequest(API_ENDPOINTS.getEoiExhibitionView, params).subscribe((res: any) => {
      if (res.status) {
        this.exhibitionData = res.data;
        console.log(this.exhibitionData);
      }
    });
  }
getIndustrySector(data: any): string {
  return data?.industrySectorSelect || data?.IndustrySector || '-';
}
  safeUrl!: SafeResourceUrl;

  openFile(filePath: string) {

    const fullUrl = this.baseUrl + filePath;

    const extension = filePath.split('.').pop()?.toLowerCase();

    let type = '';

    if (extension === 'pdf') {
      type = 'pdf';
    }
    else if (['jpg', 'jpeg', 'png'].includes(extension!)) type = 'image';
    else if (['mp4', 'webm', 'ogg'].includes(extension!)) type = 'video';

    this.dialog.open(EoiExhibitionFileViewerComponent, {
      width: '80vw',
      height: '80vh',
      data: { fullUrl, type }
    });
  }


  back() {
    this.router.navigate(['/eoiexhibition-list']);
  }
}
